import React from 'react';
import { RouteComponentProps } from 'react-router';
import { useSelector } from 'react-redux';
import {
	LinkedinOutlined, MailOutlined, PauseCircleOutlined, UserOutlined,
} from '@ant-design/icons';
import { Row, Col } from 'antd';
import BasicContainer from '@copilot/common/components/containers/basic';
import { OrganizationMemberSelectors } from '@copilot/common/store/selectors/organizationMember';
import Store from '@copilot/common/store';
import UserSettings from './user';
import LinkedInSettings from './linkedin';
import EmailSettings from './email';
import PauseSettings from './pause';
import HeaderContentLayout from '../layouts/headerContent';

interface SettingsPageProps extends RouteComponentProps<{ tab?: string }> {
	hideEmails?: boolean;
	hideLinkedIn?: boolean;
	hidePause?: boolean;
	hideUser?: boolean;
}

const UserTab = (
	<span>
		<UserOutlined />
		{' '}
		User Settings
	</span>
);
const LinkedInTab = (
	<span>
		<LinkedinOutlined />
		{' '}
		LinkedIn Settings
	</span>
);
const EmailsTab = (
	<span>
		<MailOutlined />
		{' '}
		Email Notification
	</span>
);
const PauseTab = (
	<span>
		<PauseCircleOutlined />
		{' '}
		Pause All Campaigns
	</span>
);

const SettingsPage: React.FC<SettingsPageProps> = (props) => {
	const { tab = 'user' } = props.match.params;
	const {
		hideEmails, hideLinkedIn, hidePause, hideUser,
	} = props;
	const activeMember = useSelector(OrganizationMemberSelectors.getActiveMember);

	const handleTabChange = React.useCallback((key: string) => {
		const path = key === 'user' ? '/settings' : `/settings/${key}`;
		Store.History.replace(path);
	}, []);
	if (!activeMember) return null;
	const containerPadding = '20px';

	return (
		<HeaderContentLayout>
			<HeaderContentLayout.Header>
				<Row>
					<Col>
						<h2>Settings</h2>
					</Col>
				</Row>
			</HeaderContentLayout.Header>
			<HeaderContentLayout.Tabs activeKey={tab} onChange={handleTabChange}>
				{!hideUser && (
					<HeaderContentLayout.TabPanes key="user" tab={UserTab}>
						<BasicContainer style={{ padding: containerPadding }}>
							<UserSettings user={activeMember} />
						</BasicContainer>
					</HeaderContentLayout.TabPanes>
				)}
				{!hideLinkedIn && (
					<HeaderContentLayout.TabPanes key="linkedin" tab={LinkedInTab}>
						<BasicContainer style={{ padding: containerPadding }}>
							<LinkedInSettings
								user={activeMember}
								isLoggedIn={activeMember.isLinkedInLoggedIn}
							/>
						</BasicContainer>
					</HeaderContentLayout.TabPanes>
				)}
				{!hideEmails && (
					<HeaderContentLayout.TabPanes key="email" tab={EmailsTab}>
						<BasicContainer style={{ padding: containerPadding }}>
							<EmailSettings user={activeMember} />
						</BasicContainer>
					</HeaderContentLayout.TabPanes>
				)}
				{!hidePause && (
					<HeaderContentLayout.TabPanes key="pause" tab={PauseTab}>
						<BasicContainer style={{ padding: containerPadding }}>
							<PauseSettings orgMemberId={activeMember.id} />
						</BasicContainer>
					</HeaderContentLayout.TabPanes>
				)}
			</HeaderContentLayout.Tabs>
		</HeaderContentLayout>
	);
};
export default SettingsPage;
